import Scene from '../../classes/scene';
import Utils from '../../classes/utils';
import Entity from '../../classes/entity';
import Position from '../../classes/position';
import SpritePoly from '../../classes/spritePoly';
import SpritePolyPhys from '../../classes/spritePolyPhys';
import BrainScaleTest from '../brains/brainScaleTest';
import BrainPulsatingShape from '../brains/brainPulsatingShape';


export default class ScenePhysicsDemo extends Scene {
		
	constructor(args) {
		super(args);
		this.pointer = true;
	}

	init(data) {
		super.init(data);

		this.system.audio.playMusic('drum_loop');

		let scr = this.system.screen;
		let sha = this.system.shapes;
		let pal = this.system.palette;
		let f = this.system.factory;

		this.palette = {
			green: pal.green,
			red: pal.red,
			blue: pal.blue,
		};

		this.initPhysics({
			gravity: {x:0, y:0.5},
			enableSleeping: false,
			velocityIterations: 4, // 4
			constraintIterations: 2, // 2
			positionIterations: 6, // 6
		}, 1); // physicsIterations per frame update

		f.button({
			x:'100% -140', y:50, scale: 1,
			text:'exit',
			color: pal.red,
			onClick: () => {
				this.system.sceneManager.changeScene('sceneExample');
				this.system.audio.playSample('gui_tiny');
				this.system.audio.stopMusic();
			}
		});

		let e = new Entity({
			name: 'floor',
			scene: this,
			sprite: new SpritePolyPhys({
				position: new Position({ x: scr.width/2, y: scr.height*0.625, scale:1 }),
				shape: '0 0 40 0 40 680 680 680 680 0 720 0 720 720 0 720',
				color: 0x303030,
				isStatic: true
			})
		});
		e.init();
		this.entities.push(e);
		
		// let paths = [
		// 	'0 0 50 0 50 250 0 250', // plank
		// 	'50 0 100 0 100 50 150 50 150 100 100 100 100 150 50 150 50 100 0 100 0 50 50 50', // plus
		// 	'0 0 50 0 100 86.6 150 0 200 0 100 172.2', // arrow
		// 	'0 0 200 0 100 172.2', // triangle
		// 	'100 0 50 50 100 100 0 100 -50 50 0 0', // chevron
		// 	'0 0 100 0 100 100 0 100', // box
		// ];

		let i = 128;
		while(--i >= 0) {
			let e = new Entity({
				name: 'junk',
				scene: this,
				sprite: new SpritePolyPhys({
					position: new Position({
						x: Utils.randomInt(200, scr.width-200),
						y: Utils.randomInt(-6000, -100),
						scale: Utils.randomFloat(1.5, 2.5),
						rotation: Utils.randomFloat(0, Math.PI*2),
					}),
					angularVelocity: Utils.randomFloat(-0.2, 0.2),
					restitution:0.3,
					// shape: Utils.randomElement(paths),
					shape: Utils.randomElement(sha.pixeljam), // random letters from pixeljam logo
					skipEndPoint: true,
					color: Utils.randomProperty(this.palette),
					lineWeight: 2,
					interactive: true
				}),
				brain: new BrainPulsatingShape()
			});
			e.init();
			this.entities.push(e);
		}

		// add an SVG imported, multi-pathed polygon sprite entity
		let logo = new Entity({
			name: 'pixeljam',
			scene: this,
			sprite: new SpritePoly({
				position: new Position({ x: scr.width/2, y: scr.width*0.25 }),
				shape: sha.pixeljam,
				color: pal.magenta,
				lineWeight: 2
			}),
			brain: new BrainScaleTest()
		});
		logo.init();
		this.entities.push(logo);
	}

}